import { isProductionEnvironment, isStagingEnvironment } from './environment';

/**
 * Get the documentation site URL based on the current environment
 *
 * Environment mapping:
 * - local/dev/development -> https://docs-dev.lecturo.no
 * - staging -> https://docs-staging.lecturo.no
 * - prod/production -> https://docs.lecturo.no
 */
export function getDocsUrl(): string {
  // First check if explicitly set via environment variable
  const explicitUrl = import.meta.env.VITE_DOCS_URL;
  if (explicitUrl) {
    return explicitUrl;
  }

  // Use VITE_ENVIRONMENT (client's dedicated environment variable)
  const environment = import.meta.env.VITE_ENVIRONMENT;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // Check environment variable first
  if (environment) {
    if (isProductionEnvironment()) {
      return 'https://docs.lecturo.no';
    }
    if (isStagingEnvironment()) {
      return 'https://docs-staging.lecturo.no';
    }
    // local, dev, development, demo all use dev docs
    return 'https://docs-dev.lecturo.no';
  }

  // Fallback: derive from hostname
  if (hostname.includes('lecturo.no')) {
    if (hostname.includes('staging')) {
      return 'https://docs-staging.lecturo.no';
    }
    if (hostname.includes('dev')) {
      return 'https://docs-dev.lecturo.no';
    }
    // Production (lecturo.no without prefix)
    return 'https://docs.lecturo.no';
  }

  // Default for local development
  return 'https://docs-dev.lecturo.no';
}
